import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../net/http-common";
import { AxiosError } from "axios";

interface MoleculeData {
  smiles: string;
  image: string;
}

export interface stateType {
  status: "idle" | "loading" | "failed" | "successful";
  medoids: MoleculeData[];
  clusters: MoleculeData[];
  lossFigure: string;
  scatterPlot: string;
}

const initialState: stateType = {
  status: "idle",
  medoids: [],
  clusters: [],
  scatterPlot: "",
  lossFigure: "",
};

export const fetchClusterProResults = createAsyncThunk(
  "clusterPro/fetchClusterProResults",
  async ({
    smilesFile,
    smilesColumn,
    clusters,
  }: {
    smilesFile: File;
    smilesColumn: string;
    clusters: string;
  }) => {
    try {
      const response = await http.post(
        `https://services.moleculegen.com/cluster/clusterpro_api/submit`,
        {
          smiles_file: smilesFile,
          smiles_column: smilesColumn,
          num_clusters: clusters,
        },
        {
          headers: {
            accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (err: unknown) {
      if (err instanceof AxiosError) {
        throw err?.response?.data?.detail;
      } else throw err;
    }
  }
);

export const clusterProSlice = createSlice({
  name: "clusterPro",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        fetchClusterProResults.fulfilled,
        (state: stateType, action: any) => {
          state.clusters = action.payload.cluster_info;
          state.lossFigure = action.payload.loss_fig;
          state.medoids = action.payload.cluster_centers;
          state.scatterPlot = action.payload.scatter_plot;
          state.status = "successful";
        }
      )
      .addCase(fetchClusterProResults.rejected, (state, action: any) => {
        state.status = "failed";
      })
      .addCase(fetchClusterProResults.pending, (state) => {
        state.status = "loading";
      });
  },
});

export default clusterProSlice.reducer;
